const trendingBlogs: {
  id: string;
  title: string;
  publishedDate: string;
  readTime: string;
  img: string;
}[] = [
  {
    id: "1",
    title: "Trending news1",
    publishedDate: "Jan 22nd 2023",
    readTime: "8min",
    img: "../../images/trending/trending_1.jpg",
  },
  {
    id: "2",
    title: "Trending news2",
    publishedDate: "Feb 12th 2023",
    readTime: "7min",
    img: "../../images/trending/trending_2.jpg",
  },
  {
    id: "3",
    title: "Trending news3",
    publishedDate: "Mar 01st 2023",
    readTime: "12min",
    img: "../../images/trending/trending_3.jpg",
  },
  {
    id: "4",
    title: "Trending news4",
    publishedDate: "Jan 29th 2023",
    readTime: "20min",
    img: "../../images/trending/trending_4.jpg",
  },
  {
    id: "5",
    title: "Trending news5",
    publishedDate: "Jan 14th 2023",
    readTime: "3min",
    img: "../../images/trending/trending_5.jpg",
  },
];

export default trendingBlogs;
